module.exports = __webpack_public_path__ + "img/fondo.0ecad6a6.png";